import { Box, Flex, Text, Container } from '@chakra-ui/react';
import { readerSections } from '../../data/readers';
import { SeparatorHelper } from '../general/separator';

export const PeoplePage = () => {
  return (
    <Container maxW="3xl" bg="#e5e4e2" pb={10}>
      <Box paddingBottom="3" id="people">
        <Flex justify="center" align="center" gap="4">
          <Box mb={6} id="philosophy">
            <Text
              fontSize={{ base: '2xl', sm: '2xl', md: '2xl', lg: '3xl' }}
              pt={{ base: 4, md: 7 }}
              textAlign="center"
              fontFamily="'Bad Script', cursive"
            >
              Who should read Fernsology?{' '}
            </Text>
          </Box>
        </Flex>
      </Box>
      <Flex gap={4} flexWrap="wrap" justify="center">
        {readerSections.map((reader) => (
          <Box key={reader.id} flex={{ base: '100%', sm: '48%', md: '40%' }}>
            <Text fontSize={{ base: 'xl', md: 'xl' }} mb={2} id={reader.id}>
              {reader.title}
            </Text>

            <SeparatorHelper />

            <Text fontSize={{ base: 'sm', md: 'md' }} mb={4}>
              {reader.description}
            </Text>
          </Box>
        ))}
      </Flex>
    </Container>
  );
};
